import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultGetItemName = function defaultGetItemName(item) {
  return item.name;
};
var defaultGetItemIcon = function defaultGetItemIcon(item) {
  return item.icon;
};
var defaultGetItemInvert = function defaultGetItemInvert(item) {
  return item.invert;
};
var defaultGetItemBgColor = function defaultGetItemBgColor(item) {
  return item.bgColor;
};
var defaultGetItemLogo = function defaultGetItemLogo(item) {
  return item.logo;
};
var defaultGetItemImage = function defaultGetItemImage(item) {
  return item.image;
};
var defaultGetItemTagName = function defaultGetItemTagName(item) {
  return item.tagName;
};
var defaultGetItemAttributes = function defaultGetItemAttributes(item) {
  return item.attributes;
};
var defaultGetItemRef = function defaultGetItemRef(item) {
  return item.ref;
};
var defaultGetItemColor = function defaultGetItemColor(item) {
  return item.color;
};
var defaultGetItemDisabled = function defaultGetItemDisabled(item) {
  return item.disabled;
};
export var composePreparedProps = function composePreparedProps(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    getItemBgColor: props.getItemBgColor || defaultGetItemBgColor,
    getItemInvert: props.getItemInvert || defaultGetItemInvert,
    getItemIcon: props.getItemIcon || defaultGetItemIcon,
    getItemImage: props.getItemImage || defaultGetItemImage,
    getItemLogo: props.getItemLogo || defaultGetItemLogo,
    getItemName: props.getItemName || defaultGetItemName,
    getItemTagName: props.getItemTagName || defaultGetItemTagName,
    getItemAttributes: props.getItemAttributes || defaultGetItemAttributes,
    getItemRef: props.getItemRef || defaultGetItemRef,
    getItemColor: props.getItemColor || defaultGetItemColor,
    getItemDisabled: props.getItemDisabled || defaultGetItemDisabled
  });
};
export var avatarGroupGapMap = {
  l: 14,
  m: 10,
  s: 8
};
export var getAvatarProps = function getAvatarProps(item, mappers) {
  var icon = mappers.getItemIcon(item);
  var invert = mappers.getItemInvert(item);
  var image = mappers.getItemImage(item);
  var logo = mappers.getItemLogo(item);
  var name = mappers.getItemName(item);
  var color = mappers.getItemColor(item);
  var bgColor = mappers.getItemBgColor(item);
  if (image) {
    return {
      name: name,
      color: color,
      image: image
    };
  }
  if (icon) {
    return {
      name: name,
      color: color,
      invert: invert,
      icon: icon,
      bgColor: bgColor
    };
  }
  if (logo) {
    return {
      name: name,
      color: color,
      logo: logo
    };
  }
  return {
    name: name,
    color: color
  };
};